import React, { useEffect, useState } from 'react';
import './Timer.css';

function Timer({ timer, setTimer }) {
  const useTimer = () => {
    const timerDate = Date.now();
    const [initTime] = useState(timerDate);

    useEffect(() => {
      const interval = setInterval(() => {
        setTimer(Math.round((Date.now() - initTime) / 1000));
      }, 1000);
      return () => clearInterval(interval);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timerDate]);

    if (timer > 3599) {
      return new Date(timer * 1000).toISOString().slice(-13, -5);
    }
    return new Date(timer * 1000).toISOString().slice(-10, -5);
  };
  return (
    <div className='timer-container'>
      <p className='blue-text timer-text bold large-text'>Timer</p>
      <div className='timer large-shadow'>
        <p className='timer-text  bold large-text'>{useTimer()}</p>
      </div>
    </div>
  );
}
export default Timer;
